<div class="chat-options">
  <!-- profile -->
  <div class="chat-options__profile">
    <img
      class="profile-img"
      [ngSrc]="
        isSupportChatMod()
          ? 'assets/images/mock-image/support-chat.jpg'
          : (businessChatData()?.owner?.profile_image?.cropped_url?.toLowerCase() ||
              businessChatData()?.owner?.profile_image?.url | imageSource)
      "
      alt="profile"
      width="50"
      height="50" />
    <div class="profile-info">
      <h4 class="profile-info__title">
        <!-- @if (isSupportChatMod) { -->
        {{ 'chat.support' | translate }}
        <!-- } @else {
          {{ businessChatData?.owner?.last_name }}
        } -->
      </h4>
      <p class="profile-info__subtitle">
        {{ 'chat.online' | translate }}
      </p>
    </div>
  </div>
  <!-- options -->
  <div class="chat-options__option">
    <!-- translation button -->
    <div class="chat-options__languages">
      <!-- current language -->
      @if (currentLanguage) {
        <p class="chat-options__translation-label">
          {{ 'chat.current_language' | translate }} :
          {{ currentLanguage }}
        </p>
      }
      <!-- change language button -->
      <button
        class="chat-options__translation-btn"
        (click)="openChatLanguages()">
        <span>
          {{ 'chat.change_language' | translate }}
        </span>
        <span>
          <i class="iconsax translation-icon" icon-name="globe-refresh"></i>
        </span>
      </button>
    </div>
  </div>
</div>
